import crud from '@/crud/index/index'

import data from './data'
import mounted from './mounted'
import components from './components'
import methods from './methods'
import computed from './computed'

export default {
  data,
  methods,
  mounted,
  computed,
  components,
  mixins: [crud]

}



// WEBPACK FOOTER //
// ./src/app/patient/profile-professional/gadget/resources/index.js